import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Libs

// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
export const propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  order: PropTypes.number,
  handleMultiValueRemove: PropTypes.func,
}

// DefaultProps
export const defaultProps = {}

function MultiValue(props) {
  const { label, value, order, handleMultiValueRemove } = props

  const onRemoveClick = () => {
    handleMultiValueRemove({ label, value, order })
  }

  return (
    <div className={cx('multi-value')}>
      <div className={cx('multi-value-text')}>{label}</div>
      <div className={cx('multi-value-remove')} name='multi-remove' onClick={onRemoveClick}>
        <Icon.Close className={cx('multi-value-remove-icon')} />
      </div>
    </div>
  )
}

MultiValue.propTypes = propTypes
MultiValue.defaultProps = defaultProps

export default MultiValue
